export const AI_REPLY_STATUS_KEY = 'aiReplyStatus';

export function getAIReplyStatus(): string | null {
    try {
        const stored = localStorage.getItem(AI_REPLY_STATUS_KEY);
        if (stored !== null) {
            sessionStorage.removeItem(AI_REPLY_STATUS_KEY);
            return stored;
        }

        // Keep the value from the current session when upgrading from sessionStorage.
        const legacy = sessionStorage.getItem(AI_REPLY_STATUS_KEY);
        if (legacy !== null) {
            localStorage.setItem(AI_REPLY_STATUS_KEY, legacy);
            sessionStorage.removeItem(AI_REPLY_STATUS_KEY);
            return legacy;
        }
        return null;
    } catch {
        return null;
    }
}

export function setAIReplyStatus(status: unknown): string {
    const value = String(status ?? '');
    try {
        localStorage.setItem(AI_REPLY_STATUS_KEY, value);
        sessionStorage.removeItem(AI_REPLY_STATUS_KEY);
    } catch {
        // The caller still receives the normalized value when storage is unavailable.
    }
    return value;
}
